import * as React from "react";
import ScrollBar from "react-perfect-scrollbar";
import { connect } from "react-redux";
import { ScrollOptions } from "../../../constants/ScrollOptions";
import { IdStyles } from "../../../less/IdStyles";
import { selectTraderEventDetails, selectTraderEventRemainingTime, selectTraderEventTradeDetails, } from "../../../selectors/selectTraderEventInfo";
import { FarmEventDetailsContainer } from "../../generic/farm-event/FarmEventDetailsContainer";
import { List } from "../../generic/list/List";
import { actionModalClose } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { actionTraderEventBuyPackage } from "../actionTraderEventInfo";
import { TradePackage } from "./TradePackage";
export var _TraderEventDetails = function (_a) {
    var traderEventDetails = _a.traderEventDetails, onCloseClick = _a.onCloseClick, onBuyTraderPackage = _a.onBuyTraderPackage, traderEventRemainingTime = _a.traderEventRemainingTime;
    var renderPurchasePointsPackage = function (tradeItem, index) { return (React.createElement(TradePackage, { tradeItem: tradeItem, key: index, onBuyTraderPackage: onBuyTraderPackage })); };
    if (traderEventDetails == undefined) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(FarmEventDetailsContainer, { onClose: onCloseClick, remainingTime: traderEventRemainingTime },
        React.createElement("div", { className: IdStyles.PurchasePointsEventContainer + " purchase-points__event-details" },
            React.createElement("div", { className: "h100 padding--large" },
                React.createElement(ScrollBar, { component: "div", options: ScrollOptions, className: "flex flex--guts" },
                    React.createElement(List, { items: traderEventDetails.traderEventPackages, renderItem: renderPurchasePointsPackage, className: "h100" }))))));
};
var mapState = function (state) { return ({
    traderEventDetails: selectTraderEventTradeDetails(state),
    traderEventEventInfo: selectTraderEventDetails(state),
    traderEventRemainingTime: selectTraderEventRemainingTime(state),
}); };
var mapDispatch = function (dispatch) { return ({
    onBuyTraderPackage: function (offerId) { return dispatch(actionTraderEventBuyPackage(offerId)); },
    onCloseClick: function () { return dispatch(actionModalClose(IdModal.TraderEvent)); },
}); };
export var TraderEventDetails = connect(mapState, mapDispatch)(_TraderEventDetails);



//////////////////
// WEBPACK FOOTER
// ./src/features/trader-event/components/TraderEventDetails.tsx
// module id = 2957
// module chunks = 3